import { Mark } from 'prosemirror-model';

import { getNearestMarksFromSelection } from '../TableWidget.helpers';

/**
 * Store marks in memory for the table widget
 * When cells are cleared from an active state -> store the marks
 */
class MarkStore {
  private markMap: Map<number, Mark[]> = new Map();
  private static instance: MarkStore;

  setMarks(marks: Mark[], position: number) {
    if (!marks.length) return;
    let marksToStore: Mark[] = [];

    // validate the text style mark
    marks.forEach((mark) => {
      if (mark.type.name === 'textStyle') {
        // should have font size / color / font family
        if (mark.attrs.fontSize && mark.attrs.color && mark.attrs.fontFamily) {
          marksToStore.push(mark);
        }
      } else {
        marksToStore.push(mark);
      }
    });
    if (!marksToStore.length) return;

    this.markMap.set(position, marksToStore);
  }

  clearMarks(position?: number | undefined) {
    if (typeof position === 'number' && this.markMap.has(position)) {
      this.markMap.delete(position);
      return;
    }

    this.markMap.clear();
  }

  getMarks(position: number | undefined) {
    if (typeof position !== 'number' || !this.markMap.has(position)) return [];
    return this.markMap.get(position);
  }

  public static getInstance(): MarkStore {
    if (!MarkStore.instance) {
      MarkStore.instance = new MarkStore();
    }

    return MarkStore.instance;
  }
}

export { getNearestMarksFromSelection, MarkStore };
